/* ============================================================
   CardDash Theme JS
   ============================================================ */
(function() {
  'use strict';

  /* -------------------------------------------------------
     Utilities
  ------------------------------------------------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    }).format(cents / 100);
  }

  function formatMoneyDecimal(amount) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
  }).format(amount);
  }

  /* -------------------------------------------------------
     Header scroll behaviour
  ------------------------------------------------------- */
  (function initHeaderScroll() {
    var header = document.getElementById('site-header');
    if (!header) return;
    window.addEventListener('scroll', function() {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    }, { passive: true });
  })();

  /* -------------------------------------------------------
     Mega Menu
  ------------------------------------------------------- */
  (function initMegaMenu() {
    'use strict';

    /* ── State ────────────────────────────────────────── */
    var closeTimer   = null;
    var menuLocked   = false;
    var activeMenuId = null;
    var CLOSE_DELAY  = 300; // Layout.jsx: setTimeout(..., 300)

    var navItems = $$('.nav-item--has-mega');
    var menus    = $$('.mega-menu');
    var safeZone = document.getElementById('mm-safe-zone');

    /* ── Core open / close ────────────────────────────── */
    function openMenu(menuId) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }

      menus.forEach(function(m) { m.classList.remove('is-open'); });
      $$('.nav-link--btn').forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
      navItems.forEach(function(item) { item.classList.remove('is-active'); });

      activeMenuId = menuId;

      if (menuId) {
        var menu   = document.getElementById('mega-menu-' + menuId);
        var btn    = $('[data-menu="' + menuId + '"] .nav-link--btn');
        var navItm = $('[data-menu="' + menuId + '"]');
        if (menu)   { menu.classList.add('is-open'); }
        if (btn)    { btn.setAttribute('aria-expanded', 'true'); }
        if (navItm) { navItm.classList.add('is-active'); }
      }
    }

    function closeAll() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      menuLocked = false;
      openMenu(null);
    }

    /* ── Hover intent (handleMenuEnter / handleMenuLeave in Layout.jsx) ── */
    function handleMenuEnter(menuId) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      openMenu(menuId);
    }

    function handleMenuLeave() {
      if (menuLocked) return;
      closeTimer = setTimeout(function() {
        openMenu(null);
        activeMenuId = null;
      }, CLOSE_DELAY); // 300ms — exact match to reference
    }

    /* ── Click-to-lock (handleMenuClick in Layout.jsx) ── */
    function handleMenuClick(menuId) {
      if (activeMenuId === menuId && menuLocked) {
        menuLocked = false;
        openMenu(null);
        activeMenuId = null;
      } else {
        openMenu(menuId);
        menuLocked = true;
      }
    }

    /* ── Nav item events ─────────────────────────────── */
    navItems.forEach(function(item) {
      var menuId = item.dataset.menu;
      var btn    = item.querySelector('.nav-link--btn');
      item.addEventListener('mouseenter', function() { handleMenuEnter(menuId); });
      item.addEventListener('mouseleave', handleMenuLeave);
      if (btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          handleMenuClick(menuId);
        });
      }
    });

    /* ── Mega menu panels ────────────────────────────── */
    menus.forEach(function(menu) {
      menu.addEventListener('mouseenter', function() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      menu.addEventListener('mouseleave', handleMenuLeave);
    });

    /* ── Safe Zone Bridge ────────────────────────────── */
    if (safeZone) {
      safeZone.addEventListener('mouseenter', function() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      safeZone.addEventListener('mouseleave', handleMenuLeave);
    }

    /* ── Keyboard: Escape ────────────────────────────── */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && activeMenuId) { closeAll(); }
    });

    /* ── Click outside header ────────────────────────── */
    document.addEventListener('click', function(e) {
      if (activeMenuId && !e.target.closest('#site-header')) { closeAll(); }
    });

    /* ── Scroll down > 100px → close (Layout.jsx) ────── */
    var lastScrollY = window.scrollY;
    window.addEventListener('scroll', function() {
      var currentY = window.scrollY;
      if (currentY > lastScrollY && currentY > 100 && activeMenuId) { closeAll(); }
      lastScrollY = currentY;
    }, { passive: true });

  })();

  /* -------------------------------------------------------
     Mobile Menu
  ------------------------------------------------------- */
  (function initMobileMenu() {
    var openBtn  = document.getElementById('mobile-menu-open');
    var closeBtn = document.getElementById('mobile-menu-close');
    var overlay  = document.getElementById('mobile-menu-overlay');
    var menu     = document.getElementById('mobile-menu');
    if (!menu) return;

    function open()  { menu.classList.add('is-open');    overlay.classList.remove('hidden'); document.body.style.overflow = 'hidden'; }
    function close() { menu.classList.remove('is-open'); overlay.classList.add('hidden');    document.body.style.overflow = ''; }

    if (openBtn)  openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay)  overlay.addEventListener('click', close);
  })();

  /* -------------------------------------------------------
     Search Modal
  ------------------------------------------------------- */
  (function initSearch() {
    var openBtn  = document.getElementById('search-open');
    var closeBtn = document.getElementById('search-modal-close');
    var overlay  = document.getElementById('search-modal-overlay');
    var modal    = document.getElementById('search-modal');
    var input    = document.getElementById('search-modal-input');
    var results  = document.getElementById('search-results');
    var timer;
    if (!modal) return;

    function open()  { modal.classList.remove('hidden'); overlay.classList.remove('hidden'); document.body.style.overflow = 'hidden'; setTimeout(function() { if (input) input.focus(); }, 60); }
    function close() { modal.classList.add('hidden');    overlay.classList.add('hidden');    document.body.style.overflow = ''; }

    if (openBtn)  openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay)  overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); open(); }
      if (e.key === 'Escape') close();
    });

    if (input) {
      input.addEventListener('input', function() {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(function() {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              if (!products.length) {
                results.innerHTML = '<p style="padding:16px 0;color:#6B7280;font-size:14px">Geen producten gevonden.</p>';
                return;
              }
              results.innerHTML = products.map(function(p) {
                return '<a href="' + p.url + '" class="search-result">' +
                          '<div class="search-result__img-wrap">' +
                            (p.image
                              ? '<img src="' + p.image + '" alt="' + p.title + '" class="search-result__img">'
                              : '<div class="search-result__img-placeholder"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>'
                            ) +
                          '</div>' +
                          '<div class="search-result__info">' +
                            '<div class="search-result__title">' + p.title + '</div>' +
                            '<div class="search-result__price">' + formatMoneyDecimal(p.price) + '</div>' +
                          '</div>' +
                          '<svg class="search-result__arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>' +
                        '</a>';
              }).join('');
            }).catch(function() {});
        }, 300);
      });
    }
  })();

  /* -------------------------------------------------------
     Mini Cart
  ------------------------------------------------------- */
  (function initMiniCart() {
    var openBtn  = document.getElementById('mini-cart-open');
    var closeBtn = document.getElementById('mini-cart-close');
    var overlay  = document.getElementById('mini-cart-overlay');
    var drawer   = document.getElementById('mini-cart');
    var itemsEl  = document.getElementById('mini-cart-items');
    var footerEl = document.getElementById('mini-cart-footer');
    var emptyEl  = document.getElementById('mini-cart-empty');
    var totalEl  = document.getElementById('mini-cart-total');
    var countEl  = document.getElementById('cart-count');
    if (!drawer) return;

    function openCart()  { drawer.classList.add('is-open');    overlay.classList.remove('hidden'); document.body.style.overflow = 'hidden'; loadCart(); }
    function closeCart() { drawer.classList.remove('is-open'); overlay.classList.add('hidden');    document.body.style.overflow = ''; }

    function updateCount(n) {
      if (!countEl) return;
      countEl.textContent = n;
      countEl.style.display = n > 0 ? 'flex' : 'none';
    }

    function loadCart() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(renderCart)
        .catch(function() { if (itemsEl) itemsEl.innerHTML = '<p style="color:#EF4444;padding:16px;font-size:14px">Winkelwagen kon niet worden geladen.</p>'; });
    }

    var FREE_SHIPPING_THRESHOLD = 17500; // €175 in cents

    function updateShippingBar(totalCents) {
      var barEl      = document.getElementById('mini-cart-shipping-bar');
      var textEl     = document.getElementById('mini-cart-shipping-text');
      var fillEl     = document.getElementById('mini-cart-shipping-fill');
      if (!barEl) return;
      totalCents = parseInt(totalCents) || 0;
      var pct = Math.min(100, Math.round(totalCents / FREE_SHIPPING_THRESHOLD * 100));
      if (fillEl) fillEl.style.width = pct + '%';
      if (totalCents >= FREE_SHIPPING_THRESHOLD) {
        barEl.classList.add('mini-cart__shipping-bar--done');
        if (textEl) textEl.innerHTML = '🎉 Je hebt gratis verzending!';
      } else {
        barEl.classList.remove('mini-cart__shipping-bar--done');
        var remaining = FREE_SHIPPING_THRESHOLD - totalCents;
        if (textEl) textEl.innerHTML = 'Nog <strong>' + formatMoney(remaining) + '</strong> tot gratis verzending!';
      }
    }

    function changeQty(key, qty) {
      if (qty < 0) qty = 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart.items) {
          return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
            renderCart(c);
            document.dispatchEvent(new CustomEvent('carddash:cart-updated'));
          });
        }
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('carddash:cart-updated'));
      })
      .catch(function() {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
          renderCart(c);
          document.dispatchEvent(new CustomEvent('carddash:cart-updated'));
        });
      });
    }

    function renderCart(cart) {
      updateCount(cart.item_count);
      updateShippingBar(cart.total_price);
      if (cart.item_count === 0) {
        if (itemsEl)  itemsEl.innerHTML = '';
        if (footerEl) footerEl.classList.add('hidden');
        if (emptyEl)  emptyEl.classList.remove('hidden');
        return;
      }
      if (emptyEl)  emptyEl.classList.add('hidden');
      if (footerEl) footerEl.classList.remove('hidden');
      if (totalEl)  totalEl.textContent = formatMoney(cart.total_price);

      if (itemsEl) {
        itemsEl.innerHTML = cart.items.map(function(item) {
          return '<div class="mini-cart-item" data-key="' + item.key + '">' +
            '<a href="' + item.url + '">' +
              '<img src="' + (item.image || '') + '" alt="' + item.product_title + '" class="mini-cart-item__img">' +
            '</a>' +
            '<div class="mini-cart-item__info">' +
              '<div class="mini-cart-item__title">' + item.product_title + '</div>' +
              (item.variant_title && item.variant_title !== 'Default Title' ? '<div style="font-size:12px;color:#9CA3AF">' + item.variant_title + '</div>' : '') +
              '<div class="mini-cart-item__price">' + formatMoney((item.final_price || item.price) * item.quantity) + '</div>' +
              '<div class="mini-cart-item__qty-row">' +
                '<button class="mc-qty-btn mc-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Minder">−</button>' +
                '<input class="mc-qty-input" type="number" min="0" max="' + item.inventory_quantity + '" value="' + item.quantity + '" data-key="' + item.key + '" data-max="' + item.inventory_quantity + '" aria-label="Aantal">' +
                '<button class="mc-qty-btn mc-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" data-max="' + item.inventory_quantity + '" aria-label="Meer"' + (item.quantity >= item.inventory_quantity ? ' disabled' : '') + '>+</button>' +
              '</div>' +
            '</div>' +
            '<button class="mini-cart-item__remove" data-key="' + item.key + '" aria-label="Verwijderen">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>' +
            '</button>' +
          '</div>';
        }).join('');

        $$('.mini-cart-item__remove', itemsEl).forEach(function(btn) {
          btn.addEventListener('click', function() { changeQty(btn.dataset.key, 0); });
        });
        $$('.mc-qty-btn', itemsEl).forEach(function(btn) {
          btn.addEventListener('click', function() {
            var newQty = parseInt(btn.dataset.qty);
            var max    = parseInt(btn.dataset.max);
            if (isNaN(newQty) || newQty < 0) return;
            if (!isNaN(max) && newQty > max) return;
            changeQty(btn.dataset.key, newQty);
          });
        });
        $$('.mc-qty-input', itemsEl).forEach(function(input) {
          input.addEventListener('change', function() {
            var val = parseInt(input.value);
            var max = parseInt(input.dataset.max);
            if (isNaN(val) || val < 0) { input.value = input.defaultValue; return; }
            if (!isNaN(max) && val > max) { val = max; input.value = max; }
            changeQty(input.dataset.key, val);
          });
          input.addEventListener('keydown', function(e) { if (e.key === 'Enter') input.blur(); });
        });
      }
    }

    if (openBtn)  openBtn.addEventListener('click', openCart);
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay)  overlay.addEventListener('click', closeCart);

    window.CardDash = window.CardDash || {};
    window.CardDash.refreshCart  = loadCart;
    window.CardDash.renderCart   = renderCart;
    window.CardDash.updateCount  = updateCount;

    // Initialise count from server-rendered value
    if (countEl) {
      var n = parseInt(countEl.textContent) || 0;
      updateCount(n);
    }
  })();

  /* -------------------------------------------------------
     Add to Cart (product cards & product page form)
  ------------------------------------------------------- */
  (function initAddToCart() {
    // Product card ATC
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__atc');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      var originalHTML = btn.innerHTML;
      btn.innerHTML = '<svg class="cd-spin" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></svg>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function(r) { return r.json(); })
        .then(function() {
          btn.classList.add('added');
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> Toegevoegd!';
          if (window.CardDash && window.CardDash.refreshCart) window.CardDash.refreshCart();
          setTimeout(function() {
            btn.disabled = false;
            btn.classList.remove('added');
            btn.innerHTML = originalHTML;
          }, 2000);
        })
        .catch(function() {
          btn.disabled = false;
          btn.innerHTML = 'Fout — Probeer opnieuw';
        });
    });

  })();

  /* -------------------------------------------------------
     Cart page — qty update & remove
  ------------------------------------------------------- */
  (function initCartPage() {
    document.addEventListener('click', function(e) {
      var minus  = e.target.closest('.cart-qty-minus');
      var plus   = e.target.closest('.cart-qty-plus');
      var remove = e.target.closest('.cart-item__remove');
      var btn    = minus || plus || remove;
      if (!btn) return;

      var key = btn.dataset.key;
      var qty = btn.dataset.qty !== undefined ? parseInt(btn.dataset.qty) : 0;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r) { return r.json(); })
        .then(function() { window.location.reload(); })
        .catch(function() {});
    });
  })();

  /* -------------------------------------------------------
     Stats — animated counter (smooth, no flicker)
  ------------------------------------------------------- */
  (function initCounters() {
    var counters = $$('.js-counter-any');
    if (!counters.length) return;

    function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

    function animateCounter(el) {
      var isDecimal = el.dataset.isDecimal === 'true';
      var target    = isDecimal
        ? parseFloat(el.dataset.display.replace(',', '.')) || 0
        : parseInt(el.dataset.target, 10) || 0;
      var duration  = 1800;
      var startTs   = null;

      function tick(ts) {
        if (!startTs) startTs = ts;
        var elapsed  = ts - startTs;
        var progress = Math.min(elapsed / duration, 1);
        var eased    = easeOutQuart(progress);

        if (isDecimal) {
          var val = (eased * target).toFixed(1).replace('.', ',');
          el.textContent = val;
        } else {
          var val = Math.round(eased * target);
          el.textContent = val.toLocaleString('nl-NL');
        }

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          el.textContent = isDecimal
            ? target.toFixed(1).replace('.', ',')
            : target.toLocaleString('nl-NL');
        }
      }
      requestAnimationFrame(tick);
    }

    var triggered = false;
    var grid = counters[0].closest('.stats-grid') || counters[0];
    var observer = new IntersectionObserver(function(entries) {
      if (triggered) return;
      if (!entries.some(function(e) { return e.isIntersecting; })) return;
      triggered = true;
      observer.disconnect();
      counters.forEach(function(el) { animateCounter(el); });
    }, { threshold: 0.3 });
    observer.observe(grid);
  })();

  /* -------------------------------------------------------
     Newsletter — success state
  ------------------------------------------------------- */
  (function initNewsletter() {
    var form    = document.getElementById('newsletter-form');
    var success = document.getElementById('newsletter-success');
    var wrap    = document.getElementById('newsletter-form-wrap');
    if (!form) return;
    form.addEventListener('submit', function() {
      setTimeout(function() {
        if (wrap)    wrap.classList.add('hidden');
        if (success) success.classList.remove('hidden');
      }, 800);
    });
  })();

  /* -------------------------------------------------------
     Filter toggle (mobile)
  ------------------------------------------------------- */
  (function initFilters() {
    var toggleBtn = document.getElementById('filter-toggle');
    var filters   = document.getElementById('collection-filters');
    var clearBtn  = document.getElementById('clear-filters');
    if (toggleBtn && filters) {
      toggleBtn.addEventListener('click', function() { filters.classList.toggle('is-open'); });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function() { window.location.href = window.location.pathname; });
    }
  })();

  /* -------------------------------------------------------
     Wishlist — localStorage with full product data stored
  ------------------------------------------------------- */
  (function initWishlist() {
    function getIds() {
      try { return JSON.parse(localStorage.getItem('carddash_wishlist') || '[]'); } catch(e) { return []; }
    }
    function saveIds(list) {
      try { localStorage.setItem('carddash_wishlist', JSON.stringify(list)); } catch(e) {}
    }
    function getData() {
      try { return JSON.parse(localStorage.getItem('carddash_wishlist_data') || '[]'); } catch(e) { return []; }
    }
    function saveData(list) {
      try { localStorage.setItem('carddash_wishlist_data', JSON.stringify(list)); } catch(e) {}
    }

    function updateBtns() {
      var ids = getIds();
      $$('.wishlist-btn').forEach(function(btn) {
        var id = String(btn.dataset.productId);
        var wishlisted = ids.map(String).indexOf(id) >= 0;
        btn.classList.toggle('is-wishlisted', wishlisted);
        btn.setAttribute('aria-label', wishlisted ? 'Verwijder van verlanglijst' : 'Voeg toe aan verlanglijst');
      });

      // Update wishlist count badge in header
      var wc = document.getElementById('wishlist-count');
      if (wc) { wc.textContent = ids.length; wc.style.display = ids.length > 0 ? 'flex' : 'none'; }
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var id    = String(btn.dataset.productId);
      var ids   = getIds().map(String);
      var data  = getData();
      var idx   = ids.indexOf(id);

      if (idx >= 0) {
        // Remove
        ids.splice(idx, 1);
        data = data.filter(function(d) { return String(d.id) !== id; });
      } else {
        // Add — store enough data to render wishlist page
        ids.push(id);
        data.push({
          id:        id,
          title:     btn.dataset.productTitle  || 'Product',
          url:       btn.dataset.productUrl    || '/products/' + id,
          image:     btn.dataset.productImage  || '',
          price:     btn.dataset.productPrice  || '',
          variantId: btn.dataset.variantId     || ''
        });
      }

      saveIds(ids);
      saveData(data);
      updateBtns();
      window.dispatchEvent(new CustomEvent('carddash:wishlist-updated'));
    });

    updateBtns();

    // Expose for wishlist page
    window.CardDash = window.CardDash || {};
    window.CardDash.updateWishlistBtns = updateBtns;
  })();

  /* -------------------------------------------------------
     Global CSS injected for spinner
  ------------------------------------------------------- */
  (function injectSpinnerCSS() {
    var s = document.createElement('style');
    s.textContent =
      '@keyframes cd-spin{to{transform:rotate(360deg)}}' +
      '.cd-spin{display:inline-block;animation:cd-spin .75s linear infinite;}';
    document.head.appendChild(s);
  })();



  /* -------------------------------------------------------
     Goal Pages — Scroll-in animations + SBG card entrance
     Reference: framer-motion whileInView + viewport once:true
     .gp-scroll-in: y:12 → 0, delay via data-delay attr
     .gp-strat-card: y:16 → 0, delay via data-delay attr
     .sbg-animate: y:20 → 0, delay via --card-delay CSS var
  ------------------------------------------------------- */
  (function initGoalAnimations() {
    'use strict';

    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      document.querySelectorAll('.gp-scroll-in, .gp-strat-card, .sbg-animate').forEach(function(el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    /* Wire data-delay attributes to CSS custom property */
    function prepareScrollElements(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        var delay = el.dataset.delay || '0';
        el.style.setProperty('--gp-delay', delay + 'ms');
      });
    }
    prepareScrollElements('.gp-scroll-in');
    prepareScrollElements('.gp-strat-card');

    /* Single IntersectionObserver for both gp-scroll-in + gp-strat-card */
    var scrollObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.classList.contains('gp-strat-card')) {
          el.classList.add('gp-visible');
        } else {
          el.classList.add('gp-visible');
        }
        scrollObserver.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.gp-scroll-in, .gp-strat-card').forEach(function(el) {
      scrollObserver.observe(el);
    });

    /* SBG homepage goal cards (sbg-animate) */
    var sbgObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('sbg-visible');
        sbgObserver.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('.sbg-animate').forEach(function(el) {
      sbgObserver.observe(el);
    });

  })();

})();
